import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class SelectFilter extends AbstractFilter {
  /**
   * Create new select filter
   *
   * @param {String} key
   * @param {String} label
   * @param {String} property
   * @param {Array} selectOptions
   * @param {Boolean} [emptyOption]
   * @param {String} [value]
   */
  constructor (key, label, property, placeholder, parameters, selectOptions, emptyOption, value) {
    super(key, label, property, value)

    this.type = 'SelectFilter'
    this.placeholder = placeholder
    this.parameters = parameters

    this.updateOptions(selectOptions, emptyOption)
  }

  updateOptions (selectOptions = [], emptyOption = false) {
    this.options = { placeholder: this.placeholder, selectOptions, emptyOption, ...this.parameters }
  }
}
